/* Airborne fragrance: distributed drifting wisps, with no emitter or bursts. */
(() => {
  if (customElements.get('cargrow-perfume-air')) return;
  class PerfumeAir extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      this.ctx = this.canvas?.getContext('2d');
      if (!this.ctx || this.observer) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.time = 1.4;
      let seed = 47;
      const random = () => ((seed = (seed * 16807) % 2147483647) - 1) / 2147483646;
      this.drops = Array.from({ length: 1500 }, () => ({
        position: random(), phase: random() * Math.PI * 2,
        depth: random(), spread: (random() + random() + random() - 1.5),
        speed: .018 + random() * .014, layer: Math.floor(random() * 3),
        size: .3 + random() * .85, light: .3 + random() * .7
      }));
      this.resize = () => {
        const box = this.getBoundingClientRect();
        const dpr = Math.min(devicePixelRatio || 1, 1.5);
        this.canvas.width = Math.round(box.width * dpr);
        this.canvas.height = Math.round(box.height * dpr);
        this.draw();
      };
      this.tick = now => {
        if (!this.running) return;
        this.time += Math.min((now - (this.last || now)) / 1000, .05);
        this.last = now;
        this.draw();
        this.frame = requestAnimationFrame(this.tick);
      };
      this.sync = () => {
        cancelAnimationFrame(this.frame);
        this.running = this.visible && !document.hidden && !this.motion.matches;
        this.last = 0;
        if (this.running) this.frame = requestAnimationFrame(this.tick);
        else this.draw();
      };
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.observer.observe(this);
      this.sizer = new ResizeObserver(this.resize);
      this.sizer.observe(this);
      this.motion.addEventListener('change', this.sync);
      document.addEventListener('visibilitychange', this.sync);
      this.resize();
    }
    draw() {
      const ctx = this.ctx;
      const w = this.canvas.width, h = this.canvas.height;
      if (!w || !h) return;
      ctx.setTransform(w / 700, 0, 0, h / 420, 0, 0);
      ctx.clearRect(0, 0, 700, 420);
      const time = this.motion.matches ? 1.8 : this.time;
      ctx.globalCompositeOperation = 'lighter';
      this.drops.forEach((p, i) => {
        // Each strand is populated along its whole length. Nothing shoots from a point.
        const u = (p.position + time * p.speed) % 1;
        const curve = u * Math.PI * 2 + time * .48 + p.layer * 1.8;
        const x = 90 + u * 540 + Math.sin(time * .6 + p.phase) * 17;
        const y = 212 + Math.sin(curve) * (43 + p.layer * 14)
          + Math.cos(u * 9 - time * .35 + p.layer) * 24
          + p.spread * (25 + 17 * Math.sin(curve + .8))
          + (p.layer - 1) * 26;
        const edge = Math.pow(Math.sin(u * Math.PI), .8);
        const breathing = .65 + .3 * Math.sin(time * .85 + p.phase);
        const fade = edge * breathing;
        if (i % 15 === 0) {
          const radius = 19 + p.depth * 27;
          const mist = ctx.createRadialGradient(x, y, 0, x, y, radius);
          mist.addColorStop(0, `rgba(222,208,180,${fade * .085})`);
          mist.addColorStop(1, 'rgba(222,208,180,0)');
          ctx.fillStyle = mist;
          ctx.fillRect(x - radius, y - radius, radius * 2, radius * 2);
        }
        ctx.fillStyle = `rgba(242,218,177,${fade * p.light})`;
        ctx.beginPath();
        ctx.ellipse(x, y, p.size, p.size * .8, p.phase, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.globalCompositeOperation = 'source-over';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.sizer?.disconnect();
      this.motion?.removeEventListener('change', this.sync);
      document.removeEventListener('visibilitychange', this.sync);
      this.observer = null;
    }
  }
  customElements.define('cargrow-perfume-air', PerfumeAir);
})();


